module.exports = __webpack_public_path__ + "static/media/dna_reporttraits_report.ae3b5d2d.png";